import React from 'react';

const BOUKIndependentContractorAgreement = () => {
	return (
		<div>
			<h1
				style={{
					paddingTop: '4pt',
					paddingLeft: '145pt',
					textIndent: '0pt',
					lineHeight: '13pt',
					textAlign: 'center',
				}}
			>
				Independent Contractor Agreement
			</h1>
			<h1
				style={{
					paddingLeft: '193pt',
					textIndent: '0pt',
					lineHeight: '210%',
					textAlign: 'center',
				}}
			>
				- United States BOUK BOUKERS
			</h1>
			<p style={{ textIndent: '0pt', textAlign: 'left' }}>
				<br />
			</p>
			<p
				style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}
			>
				The undersigned operator ("The CONTRACTOR"), an autonomous contractor
				involved in the operation of executing the services described by this
				Agreement, and Bouk, LLC ("BOUK," "COMPANY," "we," "us," or "our") have
				established and entered into this Agreement ("Agreement"). The
				CONTRACTOR may accept this Agreement as a lone owner or as a business
				entity. Irrespective of whether you are entitled to execute any
				Contracted Services or ever do, this Agreement will take effect from the
				date it is accepted.
			</p>
			<p style={{ textIndent: '0pt', textAlign: 'left' }}>
				<br />
			</p>
			<h1
				style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}
			>
				ESSENTIAL: KINDLY STUDY THIS AGREEMENT THOROUGHLY. PAY SPECIAL NOTICE TO
				THE RECIPROCAL ARBITRATION CLAUSE IN SEGMENT XII, AS IT NEEDS BOTH
				PARTIES TO SETTLE CONFLICTS/GRIEVANCES ON A PERSONAL BASIS, TO THE
				UTMOST DEGREE PERMISSIBLE BY LAW, VIA FULL AND BINDING ARBITRATION
				(UNLESS YOU CORRECTLY QUIT THE ARBITRATION, AS REQUIRED BELOW). BY
				CONSENTING TO THIS AGREEMENT, YOU CONFIRM THAT YOU HAVE READ AND
				COMPREHENDED ALL OF THE CONDITIONS AND TERMS, ESPECIALLY SEGMENT XII,
				AND THAT YOU HAVE DEDICATED TIME TO SEEK ANY HELP REQUIRED TO UNDERSTAND
				THE IMPLICATIONS OF ACCEPTING THIS AGREEMENT.
			</h1>
			<p style={{ textIndent: '0pt', textAlign: 'left' }}>
				<br />
			</p>
			<p
				className='s1'
				style={{
					paddingTop: '8pt',
					paddingLeft: '5pt',
					textIndent: '0pt',
					textAlign: 'justify',
				}}
			>
				<span className='h1'>
					READ ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT CAREFULLY. YOU
					EXPRESSLY CONSENT TO BE BOUND BY (1){' '}
				</span>
				BOUK CUSTOMER/USER TERMS OF<span className='s2'> </span>SERVICE
				<span className='h1'>, (2) THIS AGREEMENT, (3) </span>BOUK DRIVER/BOUKER
				PRIVACY POLICY
				<span className='h1'>
					, AND (4) BOUK E-SIGN CONSENT AGREEMENT BY ACCESSING THE BOUK PLATFORM
					AS A BOUKER.
				</span>
			</p>
			<p style={{ textIndent: '0pt', textAlign: 'left' }}>
				<br />
			</p>
			<h1
				style={{
					paddingTop: '8pt',
					paddingLeft: '5pt',
					textIndent: '0pt',
					textAlign: 'left',
				}}
			>
				RECITALS
			</h1>
			<p
				style={{
					paddingTop: '8pt',
					paddingLeft: '5pt',
					textIndent: '0pt',
					textAlign: 'justify',
				}}
			>
				BOUK is a duly and legally registered company that provides a delivery
				pick-up and drop-off services and an online marketplace platform using
				web-based and mobile application technology that connects
				drivers/boukers/contractors, and other businesses, and consumers (“BOUK
				platform” or “platform”). BOUK’s software permits registered users to
				request delivery pick-up, drop-off, and place orders for goods from
				numerous businesses. BOUK software alerts drivers/boukers that a
				delivery or pick-up request is available once such orders are placed,
				and BOUK software supports delivery accomplishment. BOUK is neither an
				eatery, a meal courier service, or a food preparatory company.
			</p>
			<p style={{ textIndent: '0pt', textAlign: 'left' }}>
				<br />
			</p>
			<p
				style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}
			>
				The CONTRACTOR is an independent pick-up and drop-off delivery service
				provider, permitted to perform the services described in this Agreement
				in the geographic location(s) where CONTRACTOR operates. The CONTRACTOR
				certifies that he or she or they have all required apparatus and
				personnel to complete the delivery and any other services envisaged by
				this Agreement in compliance with applicable laws. The CONTRACTOR wishes
				to join into this Agreement in order to be able to take advantage of
				delivery opportunities made accessible through BOUK'S platform. The
				CONTRACTOR is in full understanding and explicitly accepts that
			</p>
			<p
				style={{
					paddingTop: '4pt',
					paddingLeft: '5pt',
					textIndent: '0pt',
					textAlign: 'justify',
				}}
			>
				they are not an employee of BOUK, and that all services provided,
				including delivery services are done on their behalf and for their
				business, not BOUK'S. The CONTRACTOR fully recognizes that (i) they have
				complete control over the method in which deliveries are accomplished
				and the method by which those requests are fulfilled; (ii) they are
				unrestricted in choosing when they want to be accessible to start
				receiving delivery request; and (iii) they have the freedom of
				negotiating their earnings by, among other things, accepting or
				rejecting the opportunities relayed from the BOUK platform by
				users/customers, and they can take advantage of such opportunities to
				earn more.
			</p>
			<p style={{ textIndent: '0pt', textAlign: 'left' }}>
				<br />
			</p>
			<p
				style={{ paddingLeft: '5pt', textIndent: '0pt', textAlign: 'justify' }}
			>
				BOUK and CONTRACTOR (collectively, "the parties") agree as follows in
				consideration of the foregoing, in addition to the reciprocal promises
				duly declared hereunder:
			</p>
			<p style={{ textIndent: '0pt', textAlign: 'left' }}>
				<br />
			</p>
			<ol id='l1'>
				<li data-list-text='I.'>
					<h1
						style={{
							paddingLeft: '14pt',
							textIndent: '-9pt',
							textAlign: 'left',
						}}
					>
						OBJECTIVE OF THE AGREEMENT
					</h1>
					<ol id='l2'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								This Agreement establishes the connection between BOUK and
								CONTRACTOR, as well as the parties' individual obligations and
								rights. CONTRACTOR shall have the responsibility and authority
								to execute the "Contracted Services" as described in this
								Agreement in exchange for the commitments in this Agreement.
								Nothing in this Agreement, however, obligates CONTRACTOR to
								undertake any certain quantity of Contracted Services throughout
								the term of this Agreement, and this Agreement does not
								guarantee CONTRACTOR any specific volume of business or request
								for any specific period of time.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR is not obligated to accept or fulfill any
								"Delivery Opportunity" (as that term is defined herein) provided
								through the BOUK platform under the terms of this Agreement.
								Nonetheless, by accepting a Delivery Prospect, the CONTRACTOR
								agrees to perform the Contracted Services in compliance with all
								regulatory consumer and merchant standards, as well as the terms
								set out below.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='II.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '17pt',
							textIndent: '-12pt',
							textAlign: 'left',
						}}
					>
						OPERATIONS OF THE CONTRACTOR
					</h1>
					<ol id='l3'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR declares and demonstrates that they have the
								ability to handle an autonomously founded business that offers
								delivery and other services, that they meet all applicable laws,
								and that they have all needed permits and licenses to conduct
								any services covered by this Agreement.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR agrees to provide BOUK with information that is
								true and accurate, and to promptly inform BOUK should any
								information require updating. The CONTRACTOR shall be
								exclusively liable for deciding how to conduct their business
								and provide the Contracted Services as an independent
								contractor/enterprise.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR holds the freedom to undertake tasks (delivery
								services or other services) for other firms as an independent
								business venture, and the CONTRACTOR represents that they market
								and hold themselves out to the wider populace as an
								independently existing company. The parties understand that they
								are or may be involved in identical agreements with other
								organizations to provide the same or similar services, and
								nothing in this agreement prevents the CONTRACTOR or BOUK from
								doing so. BOUK has no authority to forbid the CONTRACTOR from
								carrying out activities for the CONTRACTOR's personal company,
								other commitments and corporations, customers, or
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								users at any moment, even if such enterprise are rivals to BOUK,
								and even while the CONTRACTOR is logged into the BOUK platform,
								as long as such services do not violate this agreement. Even
								when this Agreement must be discontinued, the CONTRACTOR's
								freedom to operate with BOUK or perform services for businesses
								that compete with BOUK will persist.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR agrees to complete the Contractual Services in a
								prompt, professional, secure, and legal manner. BOUK has no
								power to dictate the form, technique, or methods by which the
								CONTRACTOR performs the Contracted Services and will not do so.
								Instead, the CONTRACTOR is entirely responsible for identifying
								the most effective, secure, and economical method of performing
								the Contracted Services, including route choice, delivery, and
								pick-up.
							</p>
						</li>
						<li data-list-text={5}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								<a
									href='http://www.boukofficials.com/'
									rel='noreferrer'
									className='a'
									target='_blank'
								>
									If the CONTRACTOR's authority to govern the way or technique
									they utilize to conduct services changes from the standards
									envisioned in this Section, the CONTRACTOR agrees to quickly
									notify BOUK in writing at{' '}
								</a>
								<span
									style={{
										color: '#0462c1',
										fontFamily: 'Arial, sans-serif',
										fontStyle: 'normal',
										fontWeight: 'normal',
										textDecoration: 'underline',
										fontSize: '11pt',
									}}
								>
									www.boukofficials.com
								</span>
								.
							</p>
						</li>
						<li data-list-text={6}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								As a result of executing business with BOUK or participating in
								this Agreement, the CONTRACTOR is not compelled to acquire,
								rent, or hire any items, machinery, or services from BOUK.
							</p>
						</li>
						<li data-list-text={7}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								<a
									href='http://www.boukofficials.com/'
									className='a'
									rel='noreferrer'
									target='_blank'
								>
									For the prevention of unauthorized access to the CONTRACTOR’s
									account and to avoid unauthorized use of the BOUK platform, it
									is hereby agreed that the CONTRACTOR shall keep confidential
									and protect their email, phone number, password, or other
									means of accessing their account via the BOUK platform. The
									CONTRACTOR further acknowledges that unauthorized use of
									CONTRACTOR’s account, email, phone number and password could
									lead to financial loss and access to CONTRACTOR’s sensitive
									personal and account information. Therefore, disclosure of
									BOUK's account information, user ID, and/or password to any
									person or entity by the CONTRACTOR, CONTRACTOR assumes all
									risks and losses associated therewith. If the CONTRACTOR
									believes someone may attempt to use or has accessed the
									CONTRACTOR’s account without the CONTRACTOR’s permission, or
									that any other unauthorized use or security breach has
									occurred, CONTRACTOR agrees to notify BOUK at{' '}
								</a>
								www.boukofficials.com without delay.
							</p>
						</li>
						<li data-list-text={8}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR, by using the BOUK platform, equally accepts to
								be legally held accountable by the BOUK Customer Terms of
								Service and that any breach of the BOUK Customer Terms of
								Service will be considered a breach of this Agreement.
								Nevertheless, where this Agreement and the BOUK Customer Terms
								of Service conflict, the terms of this Agreement shall prevail.
							</p>
						</li>
						<li data-list-text={9}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR'S information will be used to create and account
								when signing up to be a user of the BOUK platform. The
								CONTRACTOR is precluded from signing-up to be a Bouker more than
								once by creating multiple accounts.
							</p>
						</li>
						<li data-list-text={10}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								It is hereby acknowledged by the CONTRACTOR that, when engaging
								with the BOUK platform on a mobile device, data usage and rates
								may apply.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='III.'>
					<h1
						style={{
							paddingTop: '7pt',
							paddingLeft: '23pt',
							textIndent: '-18pt',
							textAlign: 'left',
						}}
					>
						SERVICES CONTRACTED
					</h1>
					<ol id='l4'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR will be notified occasionally by the BOUK
								platform of the chance to fulfill deliveries from
								diners/restaurants/fast food places, individuals or other
								companies to customers following request placed by
								customers/user via the BOUK platform or directly
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'left',
								}}
							>
								from individuals, eateries, or other businesses (each of these
								is termed a "Delivery Opportunity").
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								By logging into the BOUK platform as a Bouker, the CONTRACTOR
								agrees to making themself accessible to receive Delivery
								Opportunities, which the CONTRACTOR may accept or decline.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Each Delivery Opportunity accepted by the CONTRACTOR
								("Contracted Service") is testament of the CONTRACTOR'S
								agreement to proceed to the restaurant or other business to
								retrieve the order in a safe and timely fashion, ensure the
								order is accurately filled according to the consumer,
								restaurant, and/or business specifications, and complete
								delivery of the order to consumers in a safe and timely fashion
								without taking any action that would alter the quality or
								presentation of the items being delivered, while at all times,
								adhering to reasonable expectations on food safety, quality and
								health standards as required by the restaurants or other
								businesses and/or applicable law. A Delivery Opportunity is
								considered complete when the order has been delivered to the
								ordering party, or, and only when applicable, placed in a
								designated area as selected by the consumer, in addition to any
								other task required for completion of the delivery. The
								CONTRACTOR agrees to timely mark a delivery as completed through
								the BOUK platform upon delivery of the order to the ordering
								party.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR acknowledges that BOUK retains the right to
								choose which, if any, Delivery Opportunities to propose to
								CONTRACTOR, and that CONTRACTOR retains the right to approve or
								decline any Delivery Opportunity.
							</p>
						</li>
						<li data-list-text={5}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR understands and agrees that the conditions of
								each Contracted Service are set by the user/customers, diner,
								and/or other business, not BOUK, and signify the expected
								outcome, not the manner by which the CONTRACTOR will achieve the
								outcome. When it is necessary in the CONTRACTOR's sensible
								discernment and business assessment, the CONTRACTOR retains the
								privilege to cancel a Contracted Service. Despite the above, the
								CONTRACTOR accepts to retain both a customer assessment and a
								customer evaluation as of the day this Agreement comes into
								force. A violation of this term represents an essential breach
								of this Agreement, and BOUK reserves the right to cancel this
								Agreement and/or disable the CONTRACTOR'S profile in the event
								of such a breach.
							</p>
						</li>
						<li data-list-text={6}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR'S interaction is entirely at the peril of the
								CONTRACTOR'S individual business, which is completely distinct
								and separate from BOUK'S business, which is to render a delivery
								pick-up, drop-off, and an online marketplace platform that links
								contractors/drivers/boukers, restaurants, and/or other
								businesses with users/customers using web-based and mobile
								application technology.
							</p>
						</li>
						<li data-list-text={7}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK is hereby authorized by the CONTRACTOR to converse with the
								CONTRACTOR, the consumer, and/or the restaurant or other
								business during the course of a Contracted Service to give help
								to the CONTRACTOR, or to allow unrestricted interaction between
								the CONTRACTOR and the user/customer, restaurant, and/or
								business, to the limits established by the CONTRACTOR, in order
								to meet the requests of deliveries. BOUK is not permitted to
								influence the way or mechanism by which CONTRACTOR accomplishes
								delivery services or other services specified by this Agreement
								under any scenarios. This currently includes, but not restricted
								to the following:
							</p>
							<ol id='l5'>
								<li data-list-text='I.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '77pt',
											textIndent: '-24pt',
											textAlign: 'left',
										}}
									>
										CONTRACTOR is not entitled or compelled or attached to a
										boss or anyone at BOUK to whom he or she or they report.
									</p>
								</li>
								<li data-list-text='II.'>
									<p
										style={{
											paddingTop: '4pt',
											paddingLeft: '77pt',
											textIndent: '-27pt',
											textAlign: 'justify',
										}}
									>
										At any stage throughout their usage of the platform to
										execute the Contracted Services, CONTRACTOR is not obligated
										to display any BOUK signs or other designation on their
										vehicle/carrier or person.
									</p>
								</li>
								<li data-list-text='III.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '77pt',
											textIndent: '-30pt',
											textAlign: 'left',
										}}
									>
										CONTRACTOR does not receive performance evaluations by BOUK.
									</p>
								</li>
								<li data-list-text='IV.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '77pt',
											textIndent: '-31pt',
											textAlign: 'left',
										}}
									>
										BOUK has little or no influence regarding CONTRACTOR's
										looks.
									</p>
								</li>
								<li data-list-text='V.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '77pt',
											textIndent: '-28pt',
											textAlign: 'justify',
										}}
									>
										BOUK does not dictate the type or grade of conveyance used
										by the CONTRACTOR.
									</p>
								</li>
							</ol>
						</li>
						<li data-list-text={8}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								If the CONTRACTOR becomes unable complete any Contracted Service
								resulting directly from the CONTRACTOR's conduct or error (a
								"Service Failure"), the CONTRACTOR will forgo all or some of the
								set remuneration for that request. If the CONTRACTOR contests
								culpability for a Service Failure, the disagreement will be
								addressed in accordance with the "Payment Disputes" section of
								this agreement.
							</p>
						</li>
						<li data-list-text={9}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								<a
									href='http://www.boukofficials.com/'
									rel='noreferrer'
									className='a'
									target='_blank'
								>
									Should the CONTRACTOR's services or extent of operation
									deviate in any way from what is envisioned in this Section,
									the CONTRACTOR shall immediately notify BOUK in writing by
									lodging a Support request through{' '}
								</a>
								<span
									style={{
										color: '#0462c1',
										fontFamily: 'Arial, sans-serif',
										fontStyle: 'normal',
										fontWeight: 'normal',
										textDecoration: 'underline',
										fontSize: '11pt',
									}}
								>
									www.boukofficials.com
								</span>
								.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='IV.'>
					<h1
						style={{
							paddingTop: '4pt',
							paddingLeft: '21pt',
							textIndent: '-16pt',
							textAlign: 'left',
						}}
					>
						CONTENT
					</h1>
					<ol id='l6'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR can offer comments, texts, images, sound,
								multimedia, material, and other data (specifically, "Content")
								using the BOUK platform. The CONTRACTOR granted BOUK a
								non-exclusive, global, copyright, continuous, sub-licensable,
								and transferrable permission to replicate, tweak, produce
								derivative works of, disseminate, promote, and otherwise utilize
								that Content, in any format and through any channels, without
								restriction by delivering Content.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								When the Content contains individual data, BOUK's
								<span className='s4'>Privacy Policy</span> explains how that
								data is used. When BOUK funds or enables the development of
								Content, BOUK would own the Content, which will be stated in
								extra terms or disclosures.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Where any of the CONTRACTOR's Content breaches or violates on
								the intellectual property or privacy rights of a third party,
								the CONTRACTOR is solely accountable and culpable. Content that
								is biased, abusive, defamatory, misleading, violent, or
								unlawful, amongst many other issues, is banned, and all relevant
								BOUK policies, including but not confined to the BOUK Terms Of
								service, must be followed.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								CONTRACTOR is entirely liable for all Content provided by
								CONTRACTOR and certifies that CONTRACTOR owns it or has the
								authority to give BOUK the rights set out in these Terms.
							</p>
						</li>
						<li data-list-text={5}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR accepts that BOUK may render translation services
								or automation devices accessible, and that such resources or
								technologies may be used to interpret the CONTRACTOR's Content.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='V.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '21pt',
							textIndent: '-16pt',
							textAlign: 'left',
						}}
					>
						PARTIES' RELATIONSHIP
					</h1>
					<ol id='l7'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The parties expressly consent that this Agreement is between two
								co-equal, distinct commercial companies that are managed and run
								differently. This Agreement is intended to establish a
								principal-independent contractor relationship rather than an
								employer-
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								employee relationship between the parties. As a result, the
								parties are not one another's employees, agencies, joint -
								venture, or partners in any way. Except as expressly specified
								in this Agreement, neither party has the authority to bind the
								other by contract or otherwise.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The elements of the Agreement retaining absolute power to BOUK
								were added exclusively to ensure the safety of users/customers
								and other CONTRACTORS using the BOUK platform, as well as to
								comply with nationwide, statewide, and municipal laws,
								regulations, and judgments thereof.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Where the number of transactions to the CONTRACTOR meets or is
								required, BOUK shall provide the CONTRACTOR with an annual
								report detailing all payments received to the CONTRACTOR on an
								applicable IRS Form 1099. All such payments, as well as any
								monetary incentives, will be reported to the proper national,
								statewide, and county revenue agencies by the CONTRACTOR.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='VI.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '21pt',
							textIndent: '-16pt',
							textAlign: 'left',
						}}
					>
						PAYMENT FOR SERVICES
					</h1>
					<ol id='l8'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR will be paid for exact Contracted Service
								executed in a sum consistent with the openly published pay
								model, which the CONTRACTOR can access{' '}
								<span className='s4'>here</span>, unless a different rate of pay
								is negotiated or the CONTRACTOR is notified of the contrary by
								BOUK in writing, or unless otherwise stated in this Agreement.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								With every purchase that involves consumer payment via the BOUK
								platform, BOUK will process payments made by consumers and
								transmit applicable payment for the Contracted Services to the
								CONTRACTOR. Payments for all Contracted Services completed in a
								given week, less the amount of cash payments that the CONTRACTOR
								receives from cash-based Contracted Services they complete, will
								be transferred, periodically (at least weekly) via direct
								deposit unless BOUK gives notice of otherwise, in writing, to
								the CONTRACTOR, or faster method of payment, via Fast Pay, is
								requested by the CONTRACTOR.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK retains the right to reduce or withhold all or a part of
								payment owed to the CONTRACTOR if BOUK reasonably suspects that
								the CONTRACTOR has defrauded or abused, or attempted to defraud
								or abuse, the platform. BOUK may from time to time provide
								CONTRACTORS the chance to earn additional money by completing
								Contracted Services at particular periods or in specific
								locations. Nothing in this Agreement prevents the parties from
								seeking a different price of compensation, and the CONTRACTOR is
								entitled to accept or decline any such offers.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK's online credit card software may allow customers to add a
								tip to be paid to the CONTRACTOR, while customers can pay a tip
								to the CONTRACTOR in cash as well. Any tip given by the
								user/customer, whether in cash or by credit card, will be
								retained in full by the CONTRACTOR. BOUK further acknowledges
								that it has no authority to intervene in the amount of tip paid
								to CONTRACTOR by customers.
							</p>
						</li>
						<li data-list-text={5}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The responsibility for verifying the accuracy of their bank
								account and/or debit card information to receive timely payments
								is squarely on the CONTRACTOR. BOUK is not responsible for lost
								or late payments due to incorrect routing and/or account
								information.
							</p>
						</li>
						<li data-list-text={6}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR agrees that, by agreeing to any separate contract
								with a third-party that will process payments owed under this
								Agreement to the CONTRACTOR, BOUK shall discharge its payment
								obligations to the CONTRACTOR by funding the amounts payable and
								directing the third-party processor to pay such funded amounts
								to the CONTRACTOR.
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								After BOUK funds and directs payment, any continuing refusal by
								the third-party processor to issue payment to CONTRACTOR shall
								be resolved by the CONTRACTOR and not BOUK.
							</p>
						</li>
						<li data-list-text={7}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK may, from time to time, offer the CONTRACTOR a cash-based
								Delivery Opportunity. The order subtotal and the CONTRACTOR
								earnings from those Delivery Opportunities will be deducted from
								CONTRACTOR’s earnings balance in the BOUK platform, and the
								CONTRACTOR will keep the cash provided by the customer.
								Tracking, reporting, and paying appropriate taxes on all tips
								received from cash-based Delivery Opportunities shall be the
								responsibility of the CONTRACTOR.
							</p>
						</li>
						<li data-list-text={8}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK may from time-to-time present unique Boukers promotions or
								referral programs, and the CONTRACTOR agrees not to falsify or
								misuse the referral programs or Bouker promotions by, for
								example, (a) altering with the location function on their
								cellphone; (b) trying to collect bonus or promotional pay when
								not eligible under relevant policies; or (c) generating new
								Bouker or consumer profiles. Such exploitation or misconduct is
								a material breach of this Agreement, and their profile may be
								deleted as a result.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='VII.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '24pt',
							textIndent: '-19pt',
							textAlign: 'left',
						}}
					>
						PAYMENT DISPUTES
					</h1>
					<ol id='l9'>
						<li data-list-text={1}>
							<p
								className='s6'
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Failure on the part of BOUK
								<a
									href='http://www.boukofficials.com/'
									rel='noreferrer'
									className='a'
									target='_blank'
								>
									: If BOUK falls short in remitting payment in a prompt or
									precise way, except as provided in Section VI(5), the
									CONTRACTOR may sought immediate payment through any lawful
									methods proposed by this Agreement and, if the CONTRACTOR
									succeeds, shall be eligible to claim rational costs sustained
									in seeking proper payment, provided, however, that the
									CONTRACTOR shall first notify BOUK in writing at{' '}
								</a>
								<span className='p'>
									www.boukofficials.com of the failure and a rational
									opportunity to remedy it be provided to BOUK.
								</span>
							</p>
						</li>
						<li data-list-text={2}>
							<p
								className='s6'
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Failure on the part of the CONTRACTOR
								<a
									href='http://www.boukofficials.com/'
									rel='noreferrer'
									className='a'
									target='_blank'
								>
									: The CONTRACTOR shall not be eligible for payment as
									indicated in the previous section if there is a Service
									Failure (this is to be decided in accordance with the rational
									discretion of BOUK). Any payment restriction will be supported
									by evidence presented by the user/customer, restaurant, or
									other company, the CONTRACTOR, and any other party with useful
									details. BOUK is responsible for determining whether a Service
									Failure was caused by the CONTRACTOR's doing or negligence.
									The CONTRACTOR may dispute BOUK's decision by any legal
									procedures provided for in this Agreement; however, the
									CONTRACTOR must inform BOUK in writing of the issue at{' '}
								</a>
								<span className='p'>
									www.boukofficials.com and provide BOUK the opportunity to
									settle the disagreement. The CONTRACTOR must include all
									supporting documentation and necessary information for the
									issue.
								</span>
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='VIII.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '27pt',
							textIndent: '-22pt',
							textAlign: 'left',
						}}
					>
						MACHINERY AND EXPENDITURE
					</h1>
					<ol id='l10'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								CONTRACTOR demonstrates that they have or can legally obtain all
								machinery, including cars, bikes, and trucks ("Equipment"),
								required to execute Contracted Services, and that CONTRACTOR is
								primarily accountable for maintaining that any mode or vehicle
								used complies with all vehicle laws relating to registration,
								safety, inspection, and operational capability.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Contractor undertakes to bear all expenditure or amount incurred
								as a result of CONTRACTOR's execution of Contracted Services,
								including but not restricted to costs associated with
								CONTRACTOR's Employees (defined below) and Machinery.
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'left',
								}}
							>
								CONTRACTOR bears all liability of harm or destruction to their
								Machinery, unless otherwise legally required.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='IX.'>
					<h1
						style={{
							paddingTop: '7pt',
							paddingLeft: '21pt',
							textIndent: '-16pt',
							textAlign: 'left',
						}}
					>
						EMPLOYEE
					</h1>
					<ol id='l11'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								For effective and adequate execution of any Contracted Services,
								the CONTRACTOR must complete and pass a background check
								conducted by a third-party contractor, subject to the
								CONTRACTOR's legal authorization, for the safeguarding of
								customers on the BOUK platform. The CONTRACTOR is under no duty
								to fulfil any Contracted Services individually, but may, to the
								measure allowed by law and subject to the terms of this
								Agreement, employ or use others (as workforce or contract
								workers of the CONTRACTOR) to conduct all or some of the
								Contracted Services, provided that any such staff members or sub
								- contractors satisfy all of the CONTRACTOR's criteria,
								including, but not limited to, accepting the terms of this
								Agreement, separate from the CONTRACTOR. If the CONTRACTOR
								provides its individual staff or subcontractors (collectively
								"Employees"), the CONTRACTOR is exclusively liable for the
								supervision and management of the Employees used to execute the
								Contracted Services.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR assumes total and complete liability for all
								payments owed to their Staff for services completed in
								connection with this Agreement, including all salaries,
								incentives, and expenditures, if any, as well as all necessary
								statewide and federal income tax withholdings, welfare benefits,
								and social security taxes, and all Employees engaged by the
								CONTRACTOR in the performance of Contracted Services under this
								agreement.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK is not a proprietor or co-employer of the CONTRACTOR's
								Employees, and shall have no liability for any salaries,
								rewards, expenditures, or other payouts owed to the CONTRACTOR's
								Staff, as well as income tax withholding, social security,
								welfare benefits, or other paycheck taxes owed to the CONTRACTOR
								or their Personnel. BOUK will not offer the CONTRACTOR or their
								workers any salaries, including holiday or leisure entitlements,
								or take part in or earn any other benefits available to BOUK's
								employees.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK has no power to remove provincial or national income taxes,
								social security taxes, unemployment benefits
								taxes/contributions, or any other local, state, or federal tax
								on behalf of the CONTRACTOR or their Employees, unless otherwise
								required by law.
							</p>
						</li>
						<li data-list-text={5}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR and their employees will not be required to put
								on a uniform or any other clothes containing BOUK's trademark or
								brand.
							</p>
						</li>
						<li data-list-text={6}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								When the CONTRACTOR employs Persons to execute the Contracted
								Services, the CONTRACTOR's Employees must abide by all of the
								conditions of this Agreement, which the CONTRACTOR must
								establish binding by a formal contract between the CONTRACTOR
								and such Employees. At minimum 7 days prior to such Staff
								executing the Contracted Services, a version of such contractual
								document must be made accessible to BOUK. Furthermore, when the
								CONTRACTOR'S Employees will be executing Contracted Services,
								the CONTRACTOR should notify BOUK. This obligation exists solely
								to guarantee that the CONTRACTOR complies with the requirements
								of this Agreement.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='X.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '18pt',
							textIndent: '-13pt',
							textAlign: 'left',
						}}
					>
						INSURANCE
					</h1>
					<ol id='l12'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								As a prerequisite of carrying out business with BOUK, the
								CONTRACTOR accepts to sustain the present insurance, in sums and
								kinds needed by law, to supply the Contracted Services and
								indemnify the CONTRACTOR during execution of the Contracted
								Services, at their personal expenses, within the duration of
								this Agreement. Refusal to obtain or ensure proper insurance
								cover will be considered a serious violation of this Agreement,
								resulting in the dissolution of the Agreement and the
								termination of the CONTRACTOR's entitlement to get Delivery
								Opportunities.
							</p>
						</li>
						<li data-list-text={2}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								ALERT OF INSURANCE COVERAGE
								<span className='p'>
									: Upon BOUK's demand, the CONTRACTOR will be requested to
									submit valid proofs of insurance as evidence of coverage. When
									the CONTRACTOR obtains, renews, or changes insurance policy
									the CONTRACTOR must produce updated documents. Prior to
									actually canceling any insurance cover necessary under this
									Agreement, the CONTRACTOR must give BOUK advance formal
									notification of at least thirty (30) days.
								</span>
							</h1>
						</li>
						<li data-list-text={3}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								WORKERS’ REMUNERATION/OCCUPATIONAL HAZARD INSURANCE
								<span className='p'>
									: The CONTRACTOR must have enough insurance that covers any
									hazards or liabilities originating from or linked to the
									CONTRACTOR'S connection with Bouk, including employees'
									compensation insurance as legally required. The CONTRACTOR
									will not be qualified for Bouk's employees' benefit plans and
									will be accountable for obtaining and sustaining his or her
									own employees' compensation or occupational hazard insurance.
									The maintenance of the CONTRACTOR’S own workers’ compensation
									insurance or occupational accident insurance will not
									disqualify the CONTRACTOR from participating in the
									Occupational Accident Insurance Policy for Boukers, which BOUK
									may make available to the CONTRACTOR.
								</span>
							</h1>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XI.'>
					<h1
						style={{
							paddingTop: '7pt',
							paddingLeft: '21pt',
							textIndent: '-16pt',
							textAlign: 'left',
						}}
					>
						INDEMNITY
					</h1>
					<ol id='l13'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK commits to cover, defend, and keep the CONTRACTOR safe from
								any and all allegations, charges, losses, lawsuits, damages,
								liabilities, and civil claims originating primarily from BOUK's
								acts in providing and assisting the CONTRACTOR's Contracted
								Services.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR accepts to indemnify, safeguard, shield and hold
								harmless BOUK, along with all parent, division, and/or related
								entities, as well as its historical and contemporary successors,
								executives, officials, stakeholders, intermediaries, legal
								teams, and workers, from any and all claims, requests, harm,
								cases, liabilities, deeds, and obligations originating wholly or
								in part from, as a consequence of, or in correlation with the
								CONTRACTOR or/and their employees actions and/or omission
								resulting from the execution of the contracted service within
								this Agreement, also comprising of bodily harm or demise of any
								individual (including to the CONTRACTOR and/or their workers) in
								addition to any obligation generating from the CONTRACTOR's
								fault to obey and follow the terms of this Agreement. The
								CONTRACTOR's obligations under this agreement include legal
								fees, including lawyers' fees, as well as the settlement of any
								final court ruling or resolution reached against BOUK or its
								parent, subsidiary, and/or related firms.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR accepts to indemnify, safeguard, shield and hold
								harmless BOUK, along with all parent, division, and/or related
								entities, as well as its historical and contemporary successors,
								executives, officials, stakeholders, intermediaries, legal
								teams, and workers, from any and all tax liabilities and
								obligations for payment of all local, state and federal taxes
								including but not constrained to paycheck taxes, self-employment
								taxes,
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'left',
								}}
							>
								employees remuneration and any levies enforced at all levels of
								government with regards to the CONTRACTOR and the CONTRACTOR's
								employees.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR accepts to indemnify, safeguard, shield and hold
								harmless BOUK, along with all parent, division, and/or related
								entities, as well as its historical and contemporary successors,
								executives, officials, stakeholders, intermediaries, legal
								teams, and workers, from any and all expenditure of CONTRACTOR’s
								organization, including, but not restricted to, the cost and
								obligations for any and all required insurance at all levels of
								government, permits, taxes, and evaluation of any and all
								governing bureaus, or local authorities.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XII.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '24pt',
							textIndent: '-19pt',
							textAlign: 'left',
						}}
					>
						MUTUAL ARBITRATION PROVISION
					</h1>
					<ol id='l14'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The Parties consent to this Reciprocal Arbitration Clause, to be
								governed by the Federal Arbitration Act (9 U.S.C. §§ 1-16)
								(“FAA”) and which specifies the conditions to any and all
								disputes that may originate from or are associated to this
								Agreement, including but not restricted to the CONTRACTOR's
								categorization as an independent contractor, the CONTRACTOR's
								fulfilment of Contracted Services to customers, diners, shops or
								other businesses, the income received by the CONTRACTOR for
								executing request made by users/customers, eateries, or other
								businesses, the discontinuation of this Agreement and other
								areas of the CONTRACTORS association with BOUK previously,
								presently or in the future, whether originating under all laws
								at every level of government, with the inclusion of harassment,
								discrimination or retaliation claims and claims arising under or
								related to the Age Discrimination in Employment Act (or its
								state or local equivalents), Civil Rights Act of 1964 (or its
								state or local equivalents), Americans With Disabilities Act (or
								its state or local equivalents), Family Medical Leave Act (or
								its state or local equivalents), Federal Credit Reporting Act
								(or its state or local equivalents), Telephone Consumer
								Protection Act (or its state or local equivalents), or Fair
								Labor Standards Act (or its state or local equivalents), state
								and local wage and hour laws, state and local statutes or
								regulations addressing the same or similar subject matters, and
								all other federal, state or local claims arising out of or
								relating to the CONTRACTOR’s relationship or the termination of
								that relationship with BOUK.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								This Mutual Arbitration Agreement covers disputes between the
								CONTRACTOR and any BOUK affiliates, subsidiaries, successors,
								agents, and employees that generate from or associated with this
								Agreement but is not applicable to any claims that cannot be
								arbitrated under applicable law. To the extent the parties have
								both arbitrable and non-arbitrable disputes that are related,
								the arbitrable disputes shall proceed first in arbitration and
								the non-arbitrable disputes shall be stayed, and any applicable
								statutes of limitations tolled, pending completion of the
								arbitration. Even if the CONTRACTOR and/or BOUK are excluded
								from the FAA, the parties outrightly accept that the FAA will
								define this Agreement. Any disagreements over the FAA's
								applicability will be decided by an independent arbitrator. The
								state law regulating arbitration clauses in the state where the
								CONTRACTOR works will govern if the FAA does not apply for
								whatever reason.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The Parties accept candidly that unofficial attempts to settle
								conflicts can often lead to quick, minimal, and mutually
								satisfactory conclusion, and thus agree that, before any party
								seeks arbitral proceedings against the other, private dialogue
								to find casual approaches of resolution in good faith via
								videoconferencing or phone conversation must first be held. The
								initiating party shall give the other notice in writing of the
								intended informal meeting, either by themselves or through a
								counsel and the meeting shall hold
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								45 days after the other party receives such notice, except there
								is mutually agreed upon extension of time. The notice may be
								done by the official email addresses or any other convenient
								means of record. In the meantime, statute of limitations and
								other related laws shall be tolled until the informal process is
								completed.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								If the unofficial procedure fails to resolve the disagreement
								amongst the parties and either party wishes to pursue
								arbitration, the originating party must give a notice in letter
								inside the relevant statute of limitations timeframe via
								registered mail, return postage desired, or delivered by hand.
								This request for arbitration should include (1) the party
								requesting arbitration's contact details, including name and
								address (2) an explanation of the claims regarding legal and
								factual grounds, (3) a statement of the solution desired, (4)
								the sum in dispute, and (5) the party requesting arbitration's
								personal signature. Unless otherwise specified, any motion for
								arbitration by either party must be addressed to the attorney
								who served the other in the unofficial settlement agreement.
							</p>
						</li>
						<li data-list-text={5}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Arbitration Class Action Waiver.
								<span className='p'>
									By agreeing to arbitrate, both CONTRACTOR and BOUK forfeit
									their right to have any conflict or claim presented, voiced,
									or resolved as, or to take part in, a civil lawsuit, joint
									action, or delegated action.
								</span>
							</h1>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								Any assertion that all or part of this Arbitration Class Action
								Waiver is voidable, unjustifiable, invalid, or unenforceable may
								only be decided by a court of law, not by an arbitrator. If (1)
								a class, group, or delegated action is lodged and (2) an
								ultimate prosecutorial judgment is made that all or part of the
								Arbitration Civil Suit Waiver is voidable, the class,
								collaborative, and/or delegated action must be challenged in the
								law court of competent jurisdiction to that degree, but the
								segment of the Arbitration Class Action Waiver that is
								actionable shall be upheld in arbitration. All other conflicts
								over whether this Mutual Arbitration Provision is actionable,
								inadmissible, suitable, legitimate, null, or revocable, as well
								as all conflicts over the reimbursement of arbitrator or
								arbitration-organization charges, such as the scheduling of such
								fees and solutions for nonpayment, shall be decided solely by an
								arbitrator, not a court. Nothing about this paragraph is
								intended to be understood as prohibiting negotiations on a
								class-wide, collective, and/or representative grounds.
							</p>
						</li>
						<li data-list-text={6}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								This Segment and the terms included therein do not alter the
								CONTRACTOR's status as an independent contractor who is not a
								worker of BOUK or its clients, and any court settlements from
								such relationships are liable to arbitration as described in
								this Section.
							</p>
						</li>
						<li data-list-text={7}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								Except as follows, any arbitration shall be regulated by the
								International Institute for Conflict Prevention &amp;
								Resolution's CPR Administered Arbitration Rules and, when
								appropriate, the CPR Employment-Related Mass-Claims Protocol
								(collectively, the "CPR Rules"):
							</p>
							<ol id='l15'>
								<li data-list-text='a.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										One independent arbitrator (the "Arbitrator"), chosen in
										compliance with the CPR Rules, will oversee the arbitration
										tribunal. An attorney with experience in the law
										underpinning the disagreement will serve as the Arbitrator.
									</p>
								</li>
								<li data-list-text='b.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										The arbitration shall hold within 45 miles of the
										CONTRACTOR's location as of the commencement date of this
										Agreement if the parties cannot agree on a site otherwise.
									</p>
								</li>
								<li data-list-text='c.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										Except where relevant legislation offers alternatively, BOUK
										and the CONTRACTOR shall share equal filing cost and other
										related and regular administrative expenses, as are
										prevalent to both court and administrative hearings, but the
										CONTRACTOR's portion of such charges will not surpass the
										filing fee to file the claim in a court of law encompassing
										the arbitration location. BOUK will cover any expenditures
										that are particular to arbitration, such as paying of the
										Arbitrator's charges and venue lease.
									</p>
								</li>
								<li data-list-text='d.'>
									<p
										style={{
											paddingTop: '4pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										Applications to disqualify and/or moves for preliminary
										injunction may be heard by the Arbitrator, who will employ
										the Federal Rules of Civil Procedure to such motions.
									</p>
								</li>
								<li data-list-text='e.'>
									<p
										style={{
											paddingTop: '7pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										The Arbitrator may issue instructions (which includes, the
										degree allowed legally, subpoenas of third parties)
										permitting the parties to perform revelation satisfactorily
										to enable each party to organize its assertions and/or
										countermeasures, keeping in mind that arbitration is
										intended to be a faster and effective way to settle. Except
										as presented in the Arbitration Class Action Waiver, the
										Arbitrator may grant all solutions to which a party is
										entitled under applicable law and which would perhaps be
										obtainable in a legal proceeding, but the Arbitrator is not
										permitted to grant any solutions for the assertions
										introduced in arbitration that would not have been usable in
										a courtroom.
									</p>
								</li>
								<li data-list-text='f.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										The Arbitrator's ruling or judgment must be written and
										added factual findings as well as legal conclusions.
									</p>
								</li>
								<li data-list-text='g.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										The Arbitrator has the authority to impose rulings
										protecting the privacy of personal data, commercial secrets,
										and other sensitive data. Any individual with a personal
										stake in the arbitration may witness the proceeding,
										pursuant to the Arbitrator's decision or the parties'
										agreement. Any non-party may be excluded from any section of
										the proceedings by the Arbitrator.
									</p>
								</li>
								<li data-list-text='h.'>
									<p
										style={{
											paddingTop: '7pt',
											paddingLeft: '5pt',
											textIndent: '0pt',
											textAlign: 'justify',
										}}
									>
										Either the CONTRACTOR or BOUK may seek provisional or
										interim injunction from a court of law on the grounds that
										the arbitration specified in this section may be deemed
										ineffective without it.
									</p>
								</li>
								<li data-list-text='i.'>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-36pt',
											textAlign: 'justify',
										}}
									>
										The Arbitrator's decision can be enforced in any court of
										law.
									</p>
								</li>
							</ol>
						</li>
						<li data-list-text={8}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								Nothing in this Mutual Arbitration Provision restricts any
								individual from reporting to, or submitting an assertion or
								claim with, the United States Securities and Exchange
								Commission, the Equal Employment Opportunity Commission, the
								United States Department of Labor, the National Labor Relations
								Board, or the Office of Federal Contract Compliance Programs; a
								federal agency from investigating any declaration, assertion, or
								claim otherwise enclosed by this Mutual Arbitration Provision;
								or federal authorities from investigating any complaint or
								charge otherwise encased by this Mutual Arbitration Provision;
								or exempts anyone from meeting stipulated standards or seeking
								official solutions within the relevant law before charging a
								claim in arbitration. BOUK will not react or reciprocate the
								gesture against the CONTRACTOR for bringing a petition with an
								adjudicating authority or expressing rights under Section 7 of
								the National Labor Relations Act (personally or in combination
								with others).
							</p>
						</li>
						<li data-list-text={9}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								This Mutual Contract Terms does not apply to disagreements
								between the parties that are not susceptible to a pre-dispute
								arbitration clause, such as those granted by an Act of Congress
								or a legitimate, binding Executive Order.
							</p>
						</li>
						<li data-list-text={10}>
							<p
								className='s4'
								style={{
									paddingTop: '8pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								<a
									href='http://www.cpradr.org/'
									className='a'
									rel='noreferrer'
									target='_blank'
								>
									The CPR Rules can be discovered at{' '}
								</a>
								<a
									href='http://www.cpradr.org/'
									className='s7'
									rel='noreferrer'
									target='_blank'
								>
									www.cpradr.org
								</a>
								<a
									href='http://www.google.com/'
									className='a'
									rel='noreferrer'
									target='_blank'
								>
									, by using a service like{' '}
								</a>
								www.google.com<span className='s5'> </span>
								<span className='p'>
									to look for "CPR Administered Arbitration Rules" and "CPR
									Employment-Related Mass-Claims Protocol," or by requesting a
									version from BOUK's General Counsel.
								</span>
							</p>
						</li>
						<li data-list-text={11}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								The Right of the New CONTRACTOR to Opt Out of the Mutual
								Arbitration Provision.
								<span className='p'>
									Every new CONTRACTOR can provide a declaration to BOUK
									indicating that he or she or they desire to drop out from the
									MUTUAL ARBITRATION PROVISION. If a New CONTRACTOR desires or
									prefer to discontinue, he or she or they must send a BOUK
									Notice to General Counsel via First Class Mail. The
									CONTRACTOR's opt out notice should be postmarked within 30
									days of the Agreement's start date to be valid. The CONTRACTOR
									and BOUK are presumed to have consented to this Mutual
									Arbitration Provision if the CONTRACTOR does not opt out
									within 30 days of the commencement date of this Agreement.
								</span>
							</h1>
						</li>
						<li data-list-text={12}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								This Mutual Arbitration Provision overrides any and all previous
								arbitration contracts between the CONTRACTOR and BOUK and is the
								comprehensive contract pertaining to the official dispute
								resolution covered by this Mutual Arbitration Provision, except
								otherwise presented in the preceding paragraph(s).
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '5pt',
									textIndent: '0pt',
									textAlign: 'left',
								}}
							>
								SAVING CLAUSE; - If any section of this Mutual Arbitration
								Provision is found to be invalid, the balance of the Mutual
								Arbitration Provision will continue in effect.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XIII.'>
					<h1
						style={{
							paddingLeft: '27pt',
							textIndent: '-22pt',
							textAlign: 'justify',
						}}
					>
						LITIGATION CLASS ACTION WAIVER
					</h1>
					<ol id='l16'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								As much as permissible by law, differentiate and set-apart from
								the Mutual Arbitration Provision set forth in Section XII, the
								CONTRACTOR acknowledges that any hearing to bring an action in
								court generated out of or pertaining to this contract either
								because the CONTRACTOR decided to drop-out of the Mutual
								Arbitration Provision or for any other purpose, will be carried
								out entirely on a personal level, and the CONTRACTOR accepts not
								to pursue to have any scandal, claim, or conflict adjudicated by
								a personal attorney, civic lawsuit or delegated representative
								action or in any legal hearing in which the CONTRACTOR decides
								to partake in or propose to partake in a representative position
								(“Litigation Class Action Waiver”).
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR also agrees that no hearing shall be merged,
								combined, or combined with another case unless all parties to
								that case have given their prior express written authorization.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								SAVING CLAUSE; - If any portion or all of this Litigation Class
								Action Waiver is found to be invalid, unconstitutional, null, or
								revocable by a court of law, the balance of this Agreement will
								continue in force and authority.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XIV.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '29pt',
							textIndent: '-24pt',
							textAlign: 'justify',
						}}
					>
						LEGAL PROCESSES AFFECTING BOUKER ACCOUNTS
					</h1>
					<ol id='l17'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK will not dispute any provincial or national court process
								("Legal Process") issued against CONTRACTOR'S Bouker profile on
								the CONTRACTOR'S behalf and may conduct measures to comply with
								such Legal Process as BOUK deems relevant, without assuming any
								duty to the CONTRACTOR.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK may acknowledge any legal proceedings or notice that is
								served personally, by mail, email or fax to any BOUK facility or
								at the office of any agent authorized by appointment or by law
								to receive service on behalf of BOUK, even if such service is
								insufficient under law.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK may prohibit the CONTRACTOR from utilizing payment options
								other than weekly direct deposits (i.e., prohibiting use of Fast
								Pay or other payment alternatives that BOUK may offer to
								CONTRACTOR) if Legal Process is brought against CONTRACTOR’S
								Bouker account.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR shall be accountable to BOUK for any sums
								received by the CONTRACTOR through payment options other than
								weekly direct deposit that otherwise would have been withheld
								pursuant to such Legal Process, and BOUK may recoup or offset
								such amounts from any obligation owed by BOUK to the CONTRACTOR.
							</p>
						</li>
						<li data-list-text={5}>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Legal Process brought against the CONTRACTOR’S Bouker account
								may result in delays in payments to the CONTRACTOR and BOUK
								shall not be liable to the CONTRACTOR on account of any losses
								resulting from delays of such nature.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XV.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '25pt',
							textIndent: '-20pt',
							textAlign: 'left',
						}}
					>
						PROPRIETARY RIGHTS AND LICENSES
					</h1>
					<ol id='l18'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								All copyright, database rights, trademarks (registered or
								unregistered), design rights (registered or unregistered),
								patent applications, patents, and other intellectual property
								rights of any kind in the BOUK platform, as well as the
								underpinning software code and any and all rights in or sourced
								from the BOUK platform, are trademarked/proprietary/copyrighted,
								and belong either explicitly by BOUK or by BOUK's licensors and
								are secured by relevant intellectual property and other laws.
								The CONTRACTOR accepts not to utilize such proprietary data,
								resources, or intellectual property rights in any way other than
								to provide the Contracted Service in accordance with the
								provisions of this Agreement using the BOUK platform. No portion
								of the BOUK platform may be reproduced in any form or by any
								means, except as expressly permitted in the terms of this
								Agreement. Except as specifically authorized in the provisions
								of this Agreement, no section of the BOUK platform may be
								duplicated in any form or by any way. The Contractor undertakes
								to not alter, hire, mortgage, borrow, trade, redistribute, or
								reproduce derivative works reliant on the BOUK platform or any
								intellectual property rights thereof in any way, and to not
								abuse the BOUK platform or any intellectual property rights
								therein in any unlawful way.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK hereby grants the CONTRACTOR a non-comprehensive,
								non-transmissible, non-sublicensable, reversible authorization
								to use the BOUK platform specifically for the purpose of
								performing the Contracted Services in line with this Agreement's
								provisions. BOUK owns all rights, name, and interest in and to
								the BOUK platform, as well as all related intellectual property
								rights. Any such permission will expire if this Agreement is
								terminated.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Any inquiries, opinions, ideas, opinions, reviews, or other
								information ("Submissions") made by the CONTRACTOR to BOUK on
								the BOUK platform are submitted voluntarily and becomes an
								exclusive property of BOUK. BOUK shall own complete rights to
								such Submissions, including all intellectual property rights in
								them, and shall be empowered to utilize and disseminate them for
								any cause, commercial or otherwise, without credit or
								remuneration to the CONTRACTOR.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XVI.'>
					<h1
						style={{
							paddingTop: '7pt',
							paddingLeft: '28pt',
							textIndent: '-23pt',
							textAlign: 'left',
						}}
					>
						TERMINATION OF AGREEMENT
					</h1>
					<ol id='l19'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK reserves the right to nullify this Agreement and disable
								the CONTRACTOR'S Bouker profile only if the CONTRACTOR has
								expressly agreed to the BOUK POLICY, or if the CONTRACTOR has
								committed a serious violation of this Agreement. BOUK may also
								temporarily remove access to the platform of BOUK for the
								purposes of timely investigation where fraud or abuse is
								suspected, including circumvention of compliance with Legal
								Process, or when deemed necessary to protect the safety and
								security of the users of BOUK platform.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR may rescind the Contract by sending BOUK a
								written notice of 7 days.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The duties and responsibilities of the CONTRACTOR and BOUK
								deriving from this Agreement's Mutual Arbitration Provision will
								outlive its cancellation. The Deactivation Policy is prone to
								revision, despite any other condition of this Agreement; such
								adjustments shall come into force and legally enforceable on the
								parties upon BOUK'S dissemination of notice to the CONTRACTOR
								through email.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XVII.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '31pt',
							textIndent: '-26pt',
							textAlign: 'left',
						}}
					>
						THIRD PARTY SERVICES
					</h1>
					<ol id='l20'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								While using the BOUK platform, CONTRACTOR may be able to access
								services from various third parties occasionally. CONTRACTOR
								acknowledges that these services are susceptible to each
								third-party provider's user agreement. BOUK is not liable for
								these services or the conduct or errors of any third-party
								provider, and the CONTRACTOR accepts that BOUK will not be held
								liable for them.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Google Maps: As a CONTRACTOR, you may be allowed to leverage
								Google Maps in-app navigation capabilities while conducting
								Contracted Services utilizing the BOUK platform. By doing so,
								CONTRACTOR agrees that while the BOUK platform is operating,
								Google may obtain CONTRACTOR's geographic information in order
								to provide and optimize Google's services, that such information
								may also be communicated with BOUK in addition to enhancing
								BOUK's operational processes, and that Google's terms and
								privacy policy will extend to this utilization. CONTRACTOR can
								choose other navigation apps or none at all outside of the BOUK
								platform.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XVIII.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '35pt',
							textIndent: '-30pt',
							textAlign: 'left',
						}}
					>
						MODIFICATION
					</h1>
					<ol id='l21'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK reserves the right to update this Agreement from time to
								time. However, when BOUK makes major modifications to this
								Agreement, it will post the updated Agreement on the BOUK
								Platform. Any major modifications will be communicated to the
								CONTRACTOR by BOUK prior to the amended Agreement's start date.
								If the CONTRACTOR does not agree with the updated Agreement, the
								CONTRACTOR may promptly cancel the Contract as set out below.
								The CONTRACTOR's continuing access to or use of the BOUK
								platform will be considered as an acceptance of the amended
								Agreement if the CONTRACTOR does not cancel the Agreement before
								the modified Agreement comes into effect.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK reserves the right to amend data on any website connected
								to this Agreement at any moment, and such changes will enter
								into force immediately after they are posted.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								The CONTRACTOR's approval to such adjustments will be implied by
								the CONTRACTOR's continual use of the BOUK platform following
								any such amendments.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XIX.'>
					<h1
						style={{
							paddingLeft: '29pt',
							textIndent: '-24pt',
							textAlign: 'left',
						}}
					>
						ENTIRE AGREEMENT, TRANSFERABILITY, AND WAIVER
					</h1>
					<ol id='l22'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								Any prior contract amongst the parties is superseded by this
								Agreement. This Agreement reigns supreme to the degree that
								BOUK's customers expected to face Terms and Conditions Agreement
								(or revised consumer facing Terms and Conditions Agreement, if
								pertinent) is unpredictable or dispute with this Agreement; and
								this Agreement shall encompass the parties' whole mutual
								understanding with respect to the subject matter of this
								Agreement and shall not be adjusted, transformed, shifted, or
								updated in any way
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'left',
								}}
							>
								unless in formal writing or notice and approved by BOUK and the
								other party, and except BOUK updates the contract pursuant to
								SECTION XVIII.
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								This Agreement may not be allotted by any party without the
								other's formal prior approval and will tie the parties
								hereinafter, including their beneficiaries and descendants,
								except that BOUK may delegate its entitlement and
								responsibilities under this Agreement to an associate of BOUK or
								any successor(s) to its business and/or acquirer of
								significantly all of its equities or holdings. BOUK shall be
								construed to add such successor in all references to BOUK in
								this Agreement (s).
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								BOUK's or CONTRACTOR's inability to enforce stringent compliance
								with the provisions of this Agreement or to pursue any
								alternative hereunder shall not be understood as a waiver or
								renunciation of such clause or provision, which shall remain in
								full force and effect.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XX.'>
					<h1
						style={{
							paddingTop: '8pt',
							paddingLeft: '25pt',
							textIndent: '-20pt',
							textAlign: 'left',
						}}
					>
						ELECTRONIC-SIGNATURE AGREEMENT
					</h1>
					<p
						style={{
							paddingTop: '8pt',
							paddingLeft: '5pt',
							textIndent: '0pt',
							textAlign: 'justify',
						}}
					>
						This BOUK E-Sign Consent Agreement (“E-Sign Agreement”) permits BOUK
						to update users/customers/drivers/boukers/merchants and other
						businesses registered on the platform with electronic/online
						versions of notices, disclosures and other communications in
						connection with the services we offer and agreements we enter into
						with you. In this E-Sign Agreement, the words "you" and "your" mean
						any person giving consent to our use of electronic Disclosures and
						signatures as described below. The words "BOUK," "we," "us," and
						"our," mean Bouk, Inc. its affiliates, successors, assigns, and any
						designated third-party service providers acting on their behalf.
					</p>
					<ol id='l23'>
						<li data-list-text={1}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '53pt',
									textIndent: '-12pt',
									textAlign: 'left',
								}}
							>
								Scope of E-Sign Agreement
							</h1>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								This electronically signed Agreement applies to all contracts,
								regulations, conditions, notifications, permissions, invoices,
								approvals, declarations, account records, disclosures, and any
								other interaction (jointly, the "Services") that we are mandated
								legally to provide to users/customers/drivers/boukers/merchants
								and other businesses in correlation with any products, services,
								payments, or contracts we offer or join into with you now or in
								the coming years (jointly, the "Services").
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
						<li data-list-text={2}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '53pt',
									textIndent: '-12pt',
									textAlign: 'left',
								}}
							>
								Consent to Receive Disclosures Electronically
							</h1>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								By consenting to this E-Sign Agreement, you agree to the
								following:
							</p>
							<ul id='l24'>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'justify',
										}}
									>
										BOUK might send you some or all Disclosures digitally in a
										variety of ways, including but not restricted to our web
										page, any Bouk app, an URL shortener on the Bouk webpage or
										application, a push notification, an electronic mail to the
										e - mail address you supplied to us, or a SMS to the mobile
										contact number you supplied to BOUK.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'justify',
										}}
									>
										When a Disclosure becomes accessible, Bouk can, but is not
										obligated to, contact you through emails, SMS, or push
										notification. You will receive the Disclosures in a mode
										that may be saved, printed, or saved for your personal
										records.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '7pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'left',
										}}
									>
										The value of your electronic signature is the same as if you
										signed with pen.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'justify',
										}}
									>
										Irrespective of whether you really read the Disclosures we
										give to you digitally, they will hold identical meaning and
										significance as if they were supplied in hard copy.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '4pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'justify',
										}}
									>
										Bouk reserves the right to decide whether to provide a
										Disclosure electronically and whether to request your
										electronic signature for any Disclosure.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '7pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'justify',
										}}
									>
										You have reviewed this E-Sign Agreement and verified that
										you can print, screenshot or download a copy of it with your
										informations.
									</p>
									<p style={{ textIndent: '0pt', textAlign: 'left' }}>
										<br />
									</p>
								</li>
							</ul>
						</li>
						<li data-list-text={3}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '53pt',
									textIndent: '-12pt',
									textAlign: 'left',
								}}
							>
								System Requirements
							</h1>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								You understand and accept that the following hardware and
								software are required to read and/or maintain versions of the
								Disclosures:
							</p>
							<ul id='l25'>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'justify',
										}}
									>
										A laptop or desktop computer or other internet-capable
										device (such as a cell phone) (the user must have a
										functional mobile line, internet service or some other means
										of access to the internet, and your account must be an
										active account with your service provider). Your ability to
										view this page confirms that your system satisfies these
										prerequisites.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'justify',
										}}
									>
										You should have a World wide web browser that can support
										128-bit SSL encrypted connections. Your browser and
										encryption software must fulfill these criteria in order to
										view this page.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'left',
										}}
									>
										The most recent PDF reader version.
									</p>
								</li>
								<li data-list-text=''>
									<p
										style={{
											paddingTop: '8pt',
											paddingLeft: '41pt',
											textIndent: '-18pt',
											textAlign: 'left',
										}}
									>
										A functional email address.
									</p>
								</li>
							</ul>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								If our hardware or software requirements change, we'll let you
								know if there's a significant risk that you won't be able to
								view or preserve your electronic Disclosures. You reconfirm your
								permission to electronic Disclosures by choosing to use the
								Services after receiving any notice of a modification in
								hardware or software specifications.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
						<li data-list-text={4}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '53pt',
									textIndent: '-12pt',
									textAlign: 'left',
								}}
							>
								Revocation of Electronic Consent
							</h1>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								<a
									href='mailto:boukaccess@gmail.com'
									className='a'
									target='_blank'
								>
									By emailing Bouk at{' '}
								</a>
								boukaccess@gmail.com, you can withdraw your agreement to the use
								of electronic Disclosures. Your withdrawal will have no
								influence on the lawful efficacy, legality, or enforcement of
								electronic Disclosures we sent before your permission. Bouk may
								suspend or restrict access to your Bouk profile and some or all
								Services if you renounce your authorization.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
						<li data-list-text={5}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '53pt',
									textIndent: '-12pt',
									textAlign: 'left',
								}}
							>
								Paper Copies
							</h1>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								You accept that BOUK may update or amend the means for
								disseminating Disclosures as indicated below, and that at its
								discretion, BOUK can send you Disclosures in hard copy. If you
								demand a physical copy of an electronic Disclosure within a
								reasonable time period after we originally gave it to you, we
								will forward it to you free of cost. Contact Customer Support if
								you'd like a hardcopy of a Disclosure.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
						<li data-list-text={6}>
							<h1
								style={{
									paddingTop: '8pt',
									paddingLeft: '53pt',
									textIndent: '-12pt',
									textAlign: 'left',
								}}
							>
								Updating Your Information
							</h1>
							<p
								style={{
									paddingTop: '7pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								It is your sole duty to present BOUK with a valid and up-to-date
								personal email, mobile number, and other contact details. You
								accept to inform Bouk of any updates to your email,
							</p>
							<p
								style={{
									paddingTop: '4pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								mobile number, or other contact details so that Bouk can reach
								you digitally. Contact Customer Support to change your details.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
						<li data-list-text={7}>
							<h1
								style={{
									paddingTop: '7pt',
									paddingLeft: '53pt',
									textIndent: '-12pt',
									textAlign: 'left',
								}}
							>
								Acceptance
							</h1>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '0pt',
									textAlign: 'justify',
								}}
							>
								You acknowledge that you have perused and accepted the
								conditions of this Electronic Signature Agreement by signing it.
								You are therefore affirming that you satisfy the platform
								conditions stipulated previously, as well as that you have
								proved your capacity to receive, store, and examine electronic
								Disclosures by doing so. We may promptly suspend or restrict
								access to your Bouk profile and some or all Services if you do
								not consent to this Electronic Signature Agreement.
							</p>
							<p style={{ textIndent: '0pt', textAlign: 'left' }}>
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text='XXI.'>
					<h1
						style={{
							paddingLeft: '28pt',
							textIndent: '-23pt',
							textAlign: 'left',
						}}
					>
						MISCELLANEOUS
					</h1>
					<ol id='l26'>
						<li data-list-text={1}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								SEPARABILITY PROVISION: If any section of this Contract is ruled
								invalid or unconstitutional, the rest of this Agreement will
								continue in force and effect, apart from as categorically stated
								in SECTION XII,
							</p>
						</li>
						<li data-list-text={2}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								DOMINATING STATUTE: Apart from the Mutual Arbitration Provision
								in Section XII earlier in the section, which is guided by the
								Federal Arbitration Act, the legal regulations of the state in
								which CONTRACTOR undertakes the vast percentage of the services
								supplied by this Agreement shall regulate the interpretation of
								this Agreement and the rights of the parties herewith, as well
								as tangible explanation of claims brought forward pursuant to
								Section XII.
							</p>
						</li>
						<li data-list-text={3}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								CAPTIONS AND SEGMENT HEADINGS: The subtitles and segment
								headlines in this Contract are for reference only and do not
								restrict, augment, change, or impact the terms and conditions of
								this Agreement in any manner.
							</p>
						</li>
						<li data-list-text={4}>
							<p
								style={{
									paddingTop: '8pt',
									paddingLeft: '41pt',
									textIndent: '-18pt',
									textAlign: 'justify',
								}}
							>
								<a
									href='http://www.boukofficials.com/'
									className='a'
									rel='noreferrer'
									target='_blank'
								>
									NOTICE AND OPPORTUNITY TO CURE: CONTRACTOR accepts to inform
									BOUK in a written formal manner via{' '}
								</a>
								www.boukofficials.com of any infringement or presumed violation
								of these Terms, of any assertion generating out of or connected
								to this Contract, or of any allegation that CONTRACTOR's
								offerings or work plan vary in any form from what is envisaged
								in this Agreement, including but not constrained to provisions
								in Sections II (Operations of the Contractor) and III (Services
								Contracted), or if the parties' relationship varies from the
								definitions in Segments V (Parties Relationship).
							</p>
						</li>
					</ol>
				</li>
			</ol>
		</div>
	);
};

export default BOUKIndependentContractorAgreement;
